import Vue from 'vue';

const MOBILE_PLATFORMS = ['mobileWeb', 'mobileApp'];

const doesPlatformListIncludeMobile = (platformArray) => {
  if (!platformArray.length) return true;
  return platformArray.some((p) => MOBILE_PLATFORMS.includes(p));
};

export const isMobileAvailable = (item) => {
  if (item.available_in_mobile !== undefined) return !!item.available_in_mobile;
  if (Array.isArray(item.platform)) return doesPlatformListIncludeMobile(item.platform);
  return undefined;
};

export const trackNavItemClick = (itemName, item, sourceBar) => {
  const availableInMobile = isMobileAvailable(item);
  const payload = {
    item: itemName,
    source_bar: sourceBar,
    ...(availableInMobile !== undefined && { available_in_mobile: availableInMobile }),
  };
  Vue.prototype.$track('Main Menu Item Click', payload);
  if (itemName === 'client_portal_editor') {
    Vue.prototype.$track('Client Portal View');
  }
};
